import { render, staticRenderFns } from "./ButtonsCreateImportPolicy.vue?vue&type=template&id=68f832aa&"
import script from "./ButtonsCreateImportPolicy.vue?vue&type=script&lang=js&"
export * from "./ButtonsCreateImportPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports